
    const _ = require("underscore");
    module.exports = function(context){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div is="crm-survey" class="crm-survey"><h3 class="crm-survey__question mb20">'+
((__t=( context.title ))==null?'':_.escape(__t))+
'</h3><div class="crm-survey__answer"><label class="crm-survey__response"><input type="radio" name="crm-survey" value="'+
((__t=( context.yes ))==null?'':_.escape(__t))+
'" class="crm-survey__input"><span class="crm-survey__box crm-survey__box--radio"></span>'+
((__t=( context.yes ))==null?'':_.escape(__t))+
'</label></div><div class="crm-survey__answer"><label class="crm-survey__response"><input type="radio" name="crm-survey" value="'+
((__t=( context.no_rough_idea ))==null?'':_.escape(__t))+
'" class="crm-survey__input"><span class="crm-survey__box crm-survey__box--radio"></span>'+
((__t=( context.no_rough_idea ))==null?'':_.escape(__t))+
'</label></div><div class="crm-survey__answer"><label class="crm-survey__response"><input type="radio" name="crm-survey" value="'+
((__t=( context.no_browsing ))==null?'':_.escape(__t))+
'" class="crm-survey__input"><span class="crm-survey__box crm-survey__box--radio"></span>'+
((__t=( context.no_browsing ))==null?'':_.escape(__t))+
'</label></div><button disabled="disabled" class="crm-survey__submit btn btn-primary btn--large btn--full-width mt20">'+
((__t=( context.submit ))==null?'':_.escape(__t))+
'</button></div>';
return __p;
};
    